<div class="dialog_style">
  <div class="modal-header">
    @if (!isEditingProject) {
      <h4 class="modal-title" id="sample-modal-title">
        {{ constants.createProject }}
      </h4>
    }
    @if (isEditingProject) {
      <h4 class="modal-title" id="sample-modal-title">
        {{ constants.editProject }}
      </h4>
    }
    <button
      type="button"
      class="btn btn-circle btn-sm btn-ghost element-cancel"
      aria-label="Close modal"
      (click)="onCloseDialog()"
    ></button>
  </div>
  <div class="modal-body">
    @if (isLoading) {
      <si-loading-spinner></si-loading-spinner>
    }
    @if (!isLoading) {
      <form [formGroup]="createProjectForm" class="d-flex h-100">
        <si-form-container
          #formContainer
          [form]="createProjectForm"
          [enableValidationHelp]="false"
          >
          <div si-form-container-content>
            <si-form-item
              label="{{ constants.projectName }}"
              [labelWidth]="labelWidth"
              [required]="true"
              >
              <input
                type="text"
                id="name"
                class="form-control w-100"
                formControlName="name"
                required
                minlength="3"
                />
              </si-form-item>
              <!--
              <si-form-item
                label="{{ constants.businessUnit }}"
                [labelWidth]="labelWidth"
                [labelWrap]="false">
                <input
                  type="text"
                  id="businessUnit"
                  class="w-100 form-control"
                  formControlName="businessUnit"
                  />
                </si-form-item> -->
                <si-form-item
                  label="{{ constants.projectOwners }}"
                  [labelWidth]="labelWidth"
                  [labelWrap]="false"
                  >
                  @for (email of newProjectOwners; track email) {
                    <div>
                      <span class="tag"
                        >{{ email }}
                        <button
                          type="button"
                          class="btn btn-circle btn-sm btn-danger element-delete"
                          aria-label="delete"
                          (click)="RemoveFromNewOwners(email)"
                        ></button>
                      </span>
                    </div>
                  }
                  @if (isAddingOwner) {
                    <si-loading-spinner
                      class="small-spinner"
                    ></si-loading-spinner>
                  }
                </si-form-item>
                <si-form-item
                  label="{{ constants.addProjectOwner }}"
                  [labelWidth]="labelWidth"
                  [labelWrap]="false"
                  >
                  <div class="d-flex gap-2 w-100">
                    <input
                      type="email"
                      placeholder="max.mustermann@siemens.com"
                      id="newProjectOwner"
                      class="form-control flex-grow-1"
                      formControlName="newProjectOwner"
                      />
                      <button
                        type="button"
                        (click)="AddOwnerToProject()"
                        class="btn btn-primary"
                        [disabled]="isAddingOwner"
                        >
                        {{ constants.add }}
                      </button>
                    </div>
                  </si-form-item>
                  @if (!isEditingProject) {
                    <si-form-item
                      label="{{ constants.addEntraGroup }}"
                      [labelWidth]="labelWidth"
                      [labelWrap]="false"
                    >
                      <input
                        type="text"
                        id="entraGroupObjectId"
                        class="w-100 form-control"
                        formControlName="entraGroupObjectId"
                        placeholder="{{ constants.entraGroupObjectId }}"
                      />
                    </si-form-item>
                  }
                  @if (!isEditingProject) {
                    <si-form-item
                      label="{{ constants.setAsFolder }}"
                      [labelWidth]="labelWidth"
                      [labelWrap]="false"
                      >
                      <input
                        type="checkbox"
                        id="isFolder"
                        formControlName="isFolder"
                        (change)="setFolder()"
                        />
                      </si-form-item>
                    }
                    <si-form-item
                      label="{{ constants.setToFolder }}"
                      [labelWidth]="labelWidth"
                      [labelWrap]="false"
                      >
                      <div class="position-relative">
                        <si-select
                          [(value)]="selectedFolder"
                          [options]="folderList"
                        ></si-select>
                      </div>
                    </si-form-item>
                    @if (!isFolderProject) {
                      <si-form-item
                        label="{{ constants.subscriptions }}"
                        [labelWidth]="labelWidth"
                        [required]="false"
                        >
                        <div class="w-100">
                          @if (isLoadingSubscriptions) {
                            <div class="d-flex justify-content-center p-5">
                              <si-loading-spinner></si-loading-spinner>
                              <span class="ms-3">Loading subscriptions...</span>
                            </div>
                          }
                          <div class="mb-4 col-12">
                              <!-- Search bar for filtering results -->
                              <div class="position-relative mb-3 d-flex align-items-center">
                                <div class="position-relative flex-grow-1">
                                  <i class="search-bar-icon icon element-search text-secondary"></i>
                                  <input
                                    type="text"
                                    class="form-control ps-9 icon-start"
                                    placeholder="Search by Subscription ID or Name"
                                    [(ngModel)]="subscriptionSearchTerm"
                                    [ngModelOptions]="{standalone: true}"
                                    (keyup.enter)="searchSubscriptionsFromInput()"
                                    autocomplete="off"
                                    />
                                </div>
                                <div class="ms-2 d-flex gap-2">
                                  <i
                                    class="icon element-search text-primary"
                                    style="cursor: pointer; font-size: 22px; font-weight: bold;"
                                    (click)="searchSubscriptionsFromInput()"
                                    title="Search"
                                  ></i>
                                  @if (subscriptionSearchTerm) {
                                    <span
                                      class="text-danger"
                                      style="cursor: pointer; font-size: 22px; font-weight: bold; line-height: 1;"
                                      (click)="clearSubscriptionSearch()"
                                      title="Clear search"
                                    >×</span>
                                  }
                                </div>
                              </div>
                              @if (isSearchingSubscriptions) {
                                <div class="d-flex justify-content-center mb-3">
                                  <si-loading-spinner></si-loading-spinner>
                                  <span class="ms-3">Searching...</span>
                                </div>
                              }
                              @if (selectedSubscriptions.length > 0) {
                                <div class="mb-2">
                                  <span 
                                    class="badge bg-primary" 
                                    style="cursor: pointer;"
                                    (click)="toggleShowOnlySelectedSubscriptions()"
                                    title="{{ showOnlySelectedSubscriptions ? 'Show all subscriptions' : 'Show only selected subscriptions' }}">
                                    {{ selectedSubscriptions.length }} selected
                                    @if (showOnlySelectedSubscriptions) {
                                      <i class="icon element-filter ms-1"></i>
                                    }
                                  </span>
                                </div>
                              }
                              <ngx-datatable
                                class="table-element elevation-1"
                                [cssClasses]="tableConfig.cssClasses"
                                [rows]="subscriptionRows"
                                [rowHeight]="tableConfig.rowHeight"
                                [columns]="subsColumns"
                                [columnMode]="ColumnMode.force"
                                [headerHeight]="tableConfig.headerHeight"
                                [footerHeight]="0"
                                columnMode="force"
                                [selectionType]="subsSelectionType"
                                [offset]="0"
                                [count]="totalSubscriptions || 0"
                                [virtualization]="false"
                                [scrollbarV]="false"
                                style="height: auto; min-height: 300px;"
                                [selected]="selectedSubscriptions!"
                                [sortType]="SortType.single"
                                trackByProp="id"
                                (select)="onSelectSubscriptions($event)"
                                siDatatableInteraction
                                >
                                <si-empty-state
                                  empty-content
                                  icon="element-users"
                                  heading="{{ constants.noSubscriptionsAvailable }}"
                                ></si-empty-state>
                              </ngx-datatable>
                              <si-pagination
                                class="ms-auto mt-8"
                                [currentPage]="subsPageNumber + 1"
                                [totalRowCount]="showOnlySelectedSubscriptions ? selectedSubscriptions.length : (totalSubscriptions || 0)"
                                [pageSize]="pageSize"
                                forwardButtonText="forward"
                                backButtonText="back"
                                (currentPageChange)="onSubscriptionPageChange($event)"
                                >
                              </si-pagination>
                          </div>
                        </div>
                      </si-form-item>
                    }
                      @if (!isFolderProject) {
                        <si-form-item
                          label="{{ constants.kubernetesCluster }}"
                          [labelWidth]="labelWidth"
                          [required]="false"
                          >
                          <div class="w-100">
                            @if (isLoadingClusters) {
                              <div class="d-flex justify-content-center p-5">
                                <si-loading-spinner></si-loading-spinner>
                                <span class="ms-3">Loading clusters...</span>
                              </div>
                            }
                              <div class="mb-4 col-12">
                                <!-- Search bar for filtering results -->
                                <div class="position-relative mb-3 d-flex align-items-center">
                                  <div class="position-relative flex-grow-1">
                                    <i class="search-bar-icon icon element-search text-secondary"></i>
                                    <input
                                      type="text"
                                      class="form-control ps-9 icon-start"
                                      placeholder="Search by Cluster ID or Name"
                                      [(ngModel)]="clusterSearchTerm"
                                      [ngModelOptions]="{standalone: true}"
                                      (keyup.enter)="searchClustersFromInput()"
                                      autocomplete="off"
                                      />
                                  </div>
                                  <div class="ms-2 d-flex gap-2">
                                    <i
                                      class="icon element-search text-primary"
                                      style="cursor: pointer; font-size: 22px; font-weight: bold;"
                                      (click)="searchClustersFromInput()"
                                      title="Search"
                                    ></i>
                                    @if (clusterSearchTerm) {
                                      <span
                                        class="text-danger"
                                        style="cursor: pointer; font-size: 22px; font-weight: bold; line-height: 1;"
                                        (click)="clearClusterSearch()"
                                        title="Clear search"
                                      >×</span>
                                    }
                                  </div>
                                </div>
                                @if (isSearchingClusters) {
                                  <div class="d-flex justify-content-center mb-3">
                                    <si-loading-spinner></si-loading-spinner>
                                    <span class="ms-3">Searching...</span>
                                  </div>
                                }
                                @if (selectedClusters.length > 0) {
                                  <div class="mb-2">
                                    <span 
                                      class="badge bg-primary" 
                                      style="cursor: pointer;"
                                      (click)="toggleShowOnlySelectedClusters()"
                                      title="{{ showOnlySelectedClusters ? 'Show all clusters' : 'Show only selected clusters' }}">
                                      {{ selectedClusters.length }} selected
                                      @if (showOnlySelectedClusters) {
                                        <i class="icon element-filter ms-1"></i>
                                      }
                                    </span>
                                  </div>
                                }
                                <ngx-datatable
                                  class="table-element elevation-1"
                                  [rows]="clusterRows"
                                  [offset]="0"
                                  [count]="totalClusters || 0"
                                  [rowHeight]="tableConfig.rowHeight"
                                  [columns]="clusterSubsColumns"
                                  [columnMode]="ColumnMode.force"
                                  [headerHeight]="tableConfig.headerHeight"
                                  [footerHeight]="0"
                                  [selectionType]="subsSelectionType"
                                  [virtualization]="false"
                                  [scrollbarV]="false"
                                  style="height: auto; min-height: 300px;"
                                  [selected]="selectedClusters!"
                                  [sortType]="SortType.single"
                                  trackByProp="id"
                                  (select)="onSelect($event)"
                                  siDatatableInteraction
                                  >
                                  <si-empty-state
                                    empty-content
                                    icon="element-users"
                                    heading="{{ constants.noClustersAvailable }}"
                                  ></si-empty-state>
                                </ngx-datatable>
                                <si-pagination
                                  class="ms-auto mt-8"
                                  [currentPage]="clusPageNumber + 1"
                                  [totalRowCount]="showOnlySelectedClusters ? selectedClusters.length : (totalClusters || 0)"
                                  [pageSize]="pageSize"
                                  forwardButtonText="forward"
                                  backButtonText="back"
                                  (currentPageChange)="onClusterPageChange($event)"
                                  >
                                </si-pagination>
                              </div>
                          </div>
                        </si-form-item>
                      }
                      </div>
                      <div si-form-container-buttons>
                        @if (!isEditingProject) {
                          <button
                            type="button"
                            (click)="save()"
                            [disabled]="!createProjectForm.valid && isEditingProject"
                            class="btn btn-primary me-2"
                            >
                            {{ constants.save }}
                          </button>
                        }
                        @if (isEditingProject) {
                          <button
                            type="button"
                            (click)="update()"
                            [disabled]="!createProjectForm.valid && !isEditingProject"
                            class="btn btn-primary me-2"
                            >
                            {{ constants.save }}
                          </button>
                        }
                        <button type="button" (click)="cancel()" class="btn btn-secondary">
                          {{ constants.cancel }}
                        </button>
                      </div>
                    </si-form-container>
                  </form>
                }
              </div>
            </div>
